/**
 * 词库
 * 第一位是种类，A 类是不押韵，B 类是押韵
 * 第二位是字数，1 是一个字，2 是两个字
 * 第三位是平仄，- 是平，+ 是仄
 */
export default {
  'A': {
    '1': {
      '-': [
        '东', '屋', '冬', '江', '支', '微', '佳', '灰', '蒸', '庚',
        '歌', '春', '中', '花', '依', '鱼', '齐', '寒', '阳', '合',
        '麻', '文', '真', '来', '云', '人', '年', '何', '桥', '风',
        '声', '枝', '知', '人', '明',
      ],
      '+': [
        '董', '讲', '纸', '尾', '语', '巧', '雪', '感', '送', '宋',
        '沃', '绛', '未', '御', '遇', '泰', '卦', '队', '物', '问',
        '艳', '啸', '亦', '气', '雾', '木', '树', '路', '素', '步',
        '断', '故', '海', '月',
      ],
    },
    '2': {
      '-': [
        '东风', '黄昏', '平生', '人间', '十分', '匆匆', '黄花', '春风', '西风',
        '相思', '谁知', '长安', '东君', '而今', '梅花', '风吹', '悠悠',
        '桃花', '青山', '扁舟', '如今', '阑干', '神仙', '时节', '当年', '天涯', '凄凉',
        '风流', '相逢', '蓬莱', '尊前', '功名', '行人', '佳人', '归来', '江南',
        '西湖', '多情', '当时', '十年', '何时', '无人', '斜阳',
        '年年', '无情', '芙蓉',
      ],
      '+': [
        '桃李', '芳草', '风雨', '流水', '杨柳', '千里', '回首', '多少', '一曲',
        '惟有', '万里', '深处', '一片', '不是', '何处', '肠断', '富贵',
        '春色', '心事', '归去', '昨夜', '今夜', '无限', '今日', '不似', '依旧', '不见',
        '江上', '天上', '风月', '几度', '明月', '往事', '寂寞', '憔悴', '天气', '何事',
      ],
    }
  },
  'B': [

    // dong
    {
      '1': {
        '-': [
          '东', '空', '松', '通', '庸', '宫', '宗', '荣', '同', '浓', '踪'
        ],
        '+': [
          '涌', '耸', '哄', '拢', '总', '统', '送', '诵', '用', '动', '纵', '弄'
        ],
      },
      '2': {
        '-': [
          '向东', '如空', '劲松', '相通', '中庸', '天宫', '尚宗', '影踪'
        ],
        '+': [
          '起涌', '欲拢', '一统', '莫送', '无用',
        ],
      },
    },

    // ang
    {
      '1': {
        '-': [
          '亡', '塘', '扬', '旁', '昂', '桑', '芳', '刚', '杭',
          '江', '康', '郎', '昌', '帮', '茫', '苍',
        ],
        '+': [
          '望', '网', '让', '养', '丧', '荡', '放', '浪', '葬',
          '想', '向', '莽', '香',
        ],
      },
      '2': {
        '-': [
          '如蔷', '称王', '中堂', '向阳', '轻扬', '径旁', '若桑', '若芳', '几行', '漫疆', '而康',
          '似狼', '清香', '友邦', '思乡', '茫茫'
        ],
        '+': [
          '相望', '相忘', '回荡', '豪放', '相抗', '风浪', '相向', '莽莽'
        ],
      },
    },

    // an
    {
      '1': {
        '-': [
          '弯', '谈', '攀', '安', '衫', '单', '翻', '烦', '寒', '栏', '簪',
          '残', '斑', '南',
        ],
        '+': [
          '晚', '染', '叹', '盼', '暗', '散', '淡', '泛', '赶', '憾', '看',
          '赞', '伴', '漫',
        ],
      },
      '2': {
        '-': [
          '入弯', '长谈', '心安', '风散', '心烦', '言欢', '栏杆', '花残', '畏寒', '清欢'
        ],
        '+': [
          '欲染', '长叹', '相盼', '雅淡', '慵懒', '惊赞', '惟憾',
        ],
      },
    }, {

      // i
      '1': {
        '-': [
          '奇', '啼', '低', '疲', '笛', '离', '西', '匿', '弥',
        ],
        '+': [
          '起', '理', '喜', '比', '逆', '觅', '递', '祭'

        ],
      },
      '2': {
        '-': [
          '惊奇', '忽啼', '别离', '突袭', '成谜', '如泥',
        ],
        '+': [
          '风起', '嬉戏', '寻觅', '如意', '僧气',
        ],
      },
    },

    // ing
    {
      '1': {
        '-': [
          '清', '听', '迎', '停', '灵', '冰', '宁', '明', '醒',
        ],
        '+': [
          '庆', '挺', '顶', '领',
        ],
      },
      '2': {
        '-': [
          '落英', '青青', '婷婷', '冥冥', '凌凌',
        ],
        '+': [
          '安定', '起兴', '随性', '同庆', '号令',
        ],
      },
    },
  ]
}
